import Vue, { CreateElement } from '@src/vue'
import { Component } from 'vue-property-decorator'

import { Subtitle1 } from '@src/elements/typography/typography'

import { stopPropagation } from '@src/util/functions'

import './toast.sass'

@Component({
  computed: {
    toast () {
      return this.$store.state.toast
    }
  }
})
export class Toast extends Vue {

  toast: { show: boolean, message: string, fadeOut: boolean, actionText: string, actionCallback }

  render (h: CreateElement) {

    return (
      <transition name='fade' mode='out-in' appear>
        {this.toast.show ? <div class='toast'>
          <span><Subtitle1>{this.toast.message}</Subtitle1></span>

          {this.toast.actionText && this.toast.actionCallback ?
            <div class='close' onClick={this.toast.actionCallback}><Subtitle1>{this.toast.actionText}</Subtitle1></div>
            : <div class='close' onClick={this.closeToast}><Subtitle1>{this.$t('ACKNOWLEDGEMENT.DISMISS')}</Subtitle1>
            </div>}
        </div> : ''}
      </transition>)
  }

  protected closeToast (e) {
    this.$store.dispatch('closeToast')
    // click outside popup must not be triggered
    stopPropagation(e)
  }
}
